export const LABELS = {
  productCode: "Product",
  fixedTermCopy: "Fixed term",
  initialPeriodIO: "Interest only",
  initialRate: "Initial rate",
  monthlyPayment: "Monthly payment",
  reversionRate: "Reversion rate",
  reversionPayment: "Reversion payment",
  aprc: "APRC",
  maxLTV: "Max LTV",
  valuationType: "Valuation type",
  lenderFee: "Lender fee",
  ercsCopy: "ERCs",
};
